// extracted by mini-css-extract-plugin
export default {"label":"UserAvator_label__nAeO8","preview":"UserAvator_preview__jlAGF"};